import { createSlice } from '@reduxjs/toolkit';

import { PAYMENT_METHODS, FUEL_OPTIONS } from 'config/app-config';

export const initialState = {
  tariffDetails: null,
  tariffList: [],
  isLoadingTariffList: false,
  isLoadingTariffDetails: false,
  tariffListErrors: null,
  tariffDetailsErrors: null,
  currentTariff: null,
  isEconomy7: false,
  postcode: '',
  paymentMethod: PAYMENT_METHODS.MONTHLY_DIRECT_DEBIT,
  fuelType: FUEL_OPTIONS.DUAL
};

export const slice = createSlice({
  name: 'tariffInformation',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.tariffDetails = initialState.tariffDetails;
      state.tariffList = initialState.tariffList;
      state.isLoadingTariffList = initialState.isLoadingTariffList;
      state.isLoadingTariffDetails = initialState.isLoadingTariffDetails;
      state.tariffDetailsErrors = initialState.tariffDetailsErrors;
      state.tariffListErrors = initialState.tariffListErrors;
      state.currentTariff = initialState.currentTariff;
      state.isEconomy7 = initialState.isEconomy7;
      state.postcode = initialState.postcode;
      state.paymentMethod = initialState.paymentMethod;
      state.fuelType = initialState.fuelType;
    },
    setIsLoadingTariffList: (state) => {
      state.isLoadingTariffList = true;
      state.tariffListErrors = initialState.tariffListErrors;
    },
    setIsLoadingTariffDetails: (state) => {
      state.isLoadingTariffDetails = true;
      state.tariffDetailsErrors = initialState.tariffDetailsErrors;
    },
    resetTariffDetails: (state) => {
      state.tariffDetails = initialState.tariffDetails;
      state.isLoadingTariffDetails = initialState.isLoadingTariffDetails;
      state.tariffDetailsErrors = initialState.tariffDetailsErrors;
    },
    setSuccessTariffDetails: (state, { payload }) => {
      state.isLoadingTariffDetails = false;
      state.tariffDetailsErrors = initialState.tariffDetailsErrors;
      state.tariffDetails = payload.data;
    },
    setSuccessTariffList: (state, { payload }) => {
      state.isLoadingTariffList = false;
      state.tariffListErrors = initialState.tariffListErrors;
      state.tariffList = payload.data;
    },
    resetTariffList: (state) => {
      state.tariffList = initialState.tariffList;
      state.isLoadingTariffList = initialState.isLoadingTariffList;
      state.tariffListErrors = initialState.tariffListErrors;
    },
    setTariffDetailsError: (state, { payload }) => {
      state.isLoadingTariffList = false;
      state.isLoadingTariffDetails = false;
      state.tariffDetailsErrors = payload;
    },
    setTariffListError: (state, { payload }) => {
      state.isLoadingTariffList = false;
      state.isLoadingTariffDetails = false;
      state.tariffListErrors = payload;
    },
    setCurrentTariff: (state, { payload }) => {
      state.currentTariff = payload;
    },
    resetCurrentTariff: (state) => {
      state.currentTariff = initialState.currentTariff;
    },
    setIsEconomy7: (state, { payload }) => {
      state.isEconomy7 = payload;
    },
    setPostcode: (state, { payload }) => {
      state.postcode = payload;
    },
    setPaymentMethod: (state, { payload }) => {
      state.paymentMethod = payload;
    },
    setFuelType: (state, { payload }) => {
      state.fuelType = payload;
    }
  }
});

export const {
  setInitialState,
  setSuccessTariffDetails,
  setTariffDetailsError,
  setTariffListError,
  setIsLoadingTariffList,
  setIsLoadingTariffDetails,
  setIsEconomy7,
  setCurrentTariff,
  setSuccessTariffList,
  setPostcode,
  setPaymentMethod,
  setFuelType,
  resetTariffDetails,
  resetCurrentTariff,
  resetTariffList
} = slice.actions;

export const selectSlice = (state) => state[slice.name];
export const selectTariffDetails = (state) => selectSlice(state).tariffDetails;
export const selectTariffByFuel = (state, fuel) => {
  const tariffDetails = selectTariffDetails(state);

  if (!tariffDetails) {
    return null;
  }
  return selectTariffDetails(state).tariffs.find(
    (tariff) => tariff.fuel === fuel
  );
};
export const selectGasTariff = (state) => selectTariffByFuel(state, 'gas');
export const selectElectricityTariff = (state) =>
  selectTariffByFuel(state, 'electricity');
export const selectTariffList = (state) => selectSlice(state).tariffList;
export const selectIsLoadingTariffList = (state) =>
  selectSlice(state).isLoadingTariffList;
export const selectIsLoadingTariffDetails = (state) =>
  selectSlice(state).isLoadingTariffDetails;
export const selectTariffDetailsErrors = (state) =>
  selectSlice(state).tariffDetailsErrors;
export const selectTariffListErrors = (state) =>
  selectSlice(state).tariffListErrors;
export const selectIsEconomy7 = (state) => selectSlice(state).isEconomy7;
export const selectCurrentTariff = (state) => selectSlice(state).currentTariff;
export const selectPostcode = (state) => selectSlice(state).postcode;
export const selectPaymentMethod = (state) => selectSlice(state).paymentMethod;
export const selectFuelType = (state) => selectSlice(state).fuelType;

export default slice.reducer;
